<!--知识产权-->
<template>
  <div class="intellectualProperty">
    <!--专利信息-->
    <div ref="right0" class="first-content">
      <div class="title-min SourceHanSansCN">专利信息<span class="quota">{{ patentInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable52" :data="patentInfo" align="left"
                    class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="filingDate" title="申请日" width="120"/>
          <vxe-column field="name" title="专利名称"/>
          <vxe-column field="classification" title="专利类型" width="100"/>
          <vxe-column field="legalStatus" title="专利状态" width="120"/>
          <vxe-column field="applicationNumber" title="申请号" width="160"/>
          <vxe-column field="publicNumber" title="公开（公布）号" width="140"/>
          <vxe-column field="openDay" title="公开（公布）日" width="140"/>
          <vxe-column field="inventor" title="发明人"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="getpatentDetail(row)">详情</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--商标信息-->
    <div ref="right1" class="essential-content">
      <div class="title-min SourceHanSansCN">商标信息<span class="quota">{{ trademarkInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable53" :data="trademarkInfo" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="applicationDate" title="申请日期" width="120"/>
          <vxe-column field="icon" title="商标">
            <template #default="{ row }">
              <el-avatar shape="square" fit="contain" :src="row.icon" v-if="row.icon" style="width: auto;height: 50px;min-width: 50px"/>
            </template>
          </vxe-column>
          <vxe-column field="name" title="商标名称"/>
          <vxe-column field="regNumber" title="注册号"/>
          <vxe-column field="internationalType" title="国际分类"/>
          <vxe-column field="status" title="商标状态"/>
          <vxe-column field="regAnnouncementDate" title="注册公告日期"/>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="brandDetail(row)">详情</el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--作品著作权-->
    <div ref="right2" class="essential-content">
      <div class="title-min SourceHanSansCN">作品著作权<span class="quota">{{ copyrightInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable54" :data="copyrightInfo" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="name" title="作品名称"/>
          <vxe-column field="regNumber" title="登记号"/>
          <vxe-column field="type" title="作品类别"/>
          <vxe-column field="completionDate" title="创作完成日期"/>
          <vxe-column field="approvalDate" title="登记日期"/>
          <vxe-column field="firstDate" title="首次发表日期"/>
        </vxe-table>
      </div>
    </div>
    <!--网站备案-->
    <div ref="right3" class="essential-content">
      <div class="title-min SourceHanSansCN">作品著作权<span class="quota">{{ websiteFilingInfo.length }}</span></div>
      <div class="table-menu">
        <vxe-table resizable border ref="xTable55" :data="websiteFilingInfo" align="left" class="table-x-table">
          <vxe-column type="seq" width="60" title="序号" align="center"/>
          <vxe-column field="auditDate" title="审核日期" width="120"/>
          <vxe-column field="websiteName" title="网站名称"/>
          <vxe-column field="websiteUrl" title="网站首页"/>
          <vxe-column field="domain" title="域名"/>
          <vxe-column field="record" title="网站备案/许可证号">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" @click="getwebsiteFilingDetail(row)">{{row.record}}</el-link>
            </template>
          </vxe-column>
          <vxe-column field="publicSecurityFiling" title="公安备案"/>
        </vxe-table>
      </div>
    </div>
    <!--专利详情-->
    <el-dialog title="专利详情" :visible.sync="Dialog34" width="60%" top="10px" lock-scroll style="z-index: 9999">
      <patent_Details :patentDetail="patentDetail"></patent_Details>
    </el-dialog>
    <!--商标详情-->
    <el-dialog title="商标详情" :visible.sync="Dialog35" width="60%" top="10px" lock-scroll style="z-index: 9999">
      <trademark_Details :brandDetails="brandDetails" :applyPlannedSpeed="applyPlannedSpeed"></trademark_Details>
    </el-dialog>
    <!--网站备案详情-->
    <el-dialog title="网站备案详情" :visible.sync="Dialog36" width="60%" style="z-index: 9999">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">备案域名</td>
          <td class="col-td2">{{ websiteFilingDetail.domain || '-' }}</td>
          <td class="col-td1">公安备案号</td>
          <td class="col-td2">{{ websiteFilingDetail.record || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">备案地公安机关</td>
          <td class="col-td2">{{ websiteFilingDetail.publicSecurityFiling || '-' }}</td>
          <td class="col-td1">备案日期</td>
          <td class="col-td2">{{ websiteFilingDetail.auditDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">网站类型</td>
          <td class="col-td2" style="width: 85%;">{{ websiteFilingDetail.type || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import {
  getPatentById,
  patentDetails,
  getTrademarkById,
  getTrademarkDetails,
  copyrightWorks,
  WebsiteFiling,
  getWebsiteFilingDetails
} from '@/api/enterpriseDetailsApi'
import patent_Details from '@/views/enterpriseDetails/patentDetails'
import trademark_Details from '@/views/enterpriseDetails/trademarkDetails'
Vue.use(VXETable)
export default {
  name: "intellectualProperty",
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  components: {patent_Details, trademark_Details},
  data() {
    return {
      /*专利信息*/
      patentInfo: [],
      /*商标信息*/
      trademarkInfo: [],
      /*作品著作权*/
      copyrightInfo: [],
      /*网站备案*/
      websiteFilingInfo: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      /*专利详情*/
      patentDetail: {legalStatus: {reverse: false, activities: [], legalIndex: 0}},
      Dialog34: false,
      /*商标详情*/
      applyPlannedSpeed: {
        activities: [
          {content: '商标申请', timestamp: '', status: 'wait'},
          {content: '初审公告', timestamp: '', status: 'wait'},
          {content: '已注册', timestamp: '', status: 'wait'},
          {content: '终止', timestamp: '', status: 'wait'}
        ]
      },
      brandDetails: {trademarkProcess: []},
      Dialog35: false,
      /*网站备案详情*/
      websiteFilingDetail: {},
      Dialog36: false
    }
  },
  methods: {
    /*专利信息*/
    getPatentInfo() {
      getPatentById({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.patentInfo = res.content.rows;
        }
      })
    },
    /*专利详情*/
    getpatentDetail(row) {
      patentDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          if (res.content.legalStatus != '' && res.content.legalStatus != null && res.content.legalStatus != undefined) {
            if (res.content.legalStatus.indexOf(';') > -1) {
              let arr1 = res.content.legalStatus.split(';');
              let lawStatus = {reverse: false, activities: [], legalIndex: arr1.length, legalStatus: ''}
              arr1.forEach(function (info) {
                let arr2 = info.split(' ');
                lawStatus.activities.push({content: arr2[1], timestamp: arr2[0]});
                lawStatus.legalStatus = arr2[1];
              })
              res.content.legalStatus = lawStatus;
            } else {
              let arr = res.content.legalStatus.split(' ');
              let lawStatus = {reverse: false, activities: [], legalIndex: 1, legalStatus: arr[1]}
              lawStatus.activities.push({content: arr[1], timestamp: arr[0]})
              res.content.legalStatus = lawStatus;
            }
          }
          this.patentDetail = res.content;
          this.Dialog34 = true;
        }
      })
    },
    /*商标信息*/
    getTrademarkInfo() {
      getTrademarkById({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.trademarkInfo = res.content.rows;
        }
      })
    },
    /*商标详情*/
    brandDetail(row) {
      getTrademarkDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          if (res.content.trademarkProcess != '' && res.content.trademarkProcess != undefined && res.content.trademarkProcess != null) {
            res.content.trademarkProcess = JSON.parse(res.content.trademarkProcess.replace(/\'/g, '"'));
          }
          if (res.content.trademarkGazette != '' && res.content.trademarkGazette != null && res.content.trademarkGazette != undefined) {
            res.content.trademarkGazette = JSON.parse(res.content.trademarkGazette.replace("\\u005c", ""))
          }
          if (res.content.applicationDate != '' && res.content.applicationDate != null && res.content.applicationDate != undefined) {
            this.applyPlannedSpeed.activities[0].timestamp = res.content.applicationDate;
            this.applyPlannedSpeed.activities[0].status = 'finish';
          } else {
            this.applyPlannedSpeed.activities[0].timestamp = '-'
          }
          if (res.content.announcementDate != '' && res.content.announcementDate != null && res.content.announcementDate != undefined) {
            this.applyPlannedSpeed.activities[1].timestamp = res.content.announcementDate;
            this.applyPlannedSpeed.activities[1].status = 'finish';
          } else {
            this.applyPlannedSpeed.activities[1].timestamp = '-'
          }
          if (res.content.regAnnouncementDate != '' && res.content.regAnnouncementDate != null && res.content.regAnnouncementDate != undefined) {
            this.applyPlannedSpeed.activities[2].timestamp = res.content.regAnnouncementDate;
            this.applyPlannedSpeed.activities[2].status = 'finish';
          } else {
            this.applyPlannedSpeed.activities[2].timestamp = '-'
          }
          if (res.content.term != '' && res.content.term != null && res.content.term != undefined) {
            let time = res.content.term.split(' 至 ');
            let startTime = new Date()
            let endTime = new Date(time[1]);
            this.applyPlannedSpeed.activities[3].timestamp = time[1];
            if (startTime > endTime) {
              this.applyPlannedSpeed.activities[3].status = 'finish';
            }
          } else {
            this.applyPlannedSpeed.activities[3].timestamp = '-'
          }
          this.brandDetails = res.content;
          this.Dialog35 = true;
        }
      })
    },
    /*作品著作权*/
    getCopyrightWorks() {
      copyrightWorks({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.copyrightInfo = res.content.rows;
        }
      })
    },
    /*网站备案*/
    getWebsiteFiling() {
      WebsiteFiling({cid: this.corpId, request: 'form', page: 1}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.websiteFilingInfo = res.content.rows;
        }
      })
    },
    /*网站备案详情*/
    getwebsiteFilingDetail(row) {
      getWebsiteFilingDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.websiteFilingDetail = res.content;
          this.Dialog36 = true;
        }
      })
    },
    /*定位到指定位置*/
    scrollToArea(ref) {
      window.scrollTo(0, this.$refs[ref].offsetTop - 200);
    }
  },
  mounted() {
    this.getPatentInfo();
    this.getTrademarkInfo();
    this.getCopyrightWorks();
    this.getWebsiteFiling();
  }
}
</script>
<style scoped>
.intellectualProperty >>> .el-dialog__wrapper .el-dialog .el-dialog__body {
  padding: 10px 20px 20px;
  color: #333333;
}

.intellectualProperty >>> .dialog-el-table .el-table th.el-table__cell {
  background-color: #D6E9FF !important;
  color: #333333;
}

.intellectualProperty >>> .dialog-el-table .el-table {
  color: #333333 !important;
}
</style>
<style lang="scss" scoped>
.intellectualProperty {
  .first-content {
    background: white;
  }

  .essential-content {
    background: white;
    margin-top: 10px;
    padding-bottom: 20px;

    .span-red {
      color: #FE273B;
      font-weight: bold
    }

    .el-row-lightblue {
      background: #F1F7FC;
      padding: 30px 0px;
      text-align: center;
      margin: 0px 30px 10px;
    }

    .result-left {
      margin-bottom: 15px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .result-left2 {
      margin-bottom: 15px;
      margin-top: 30px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }

    .col-8 {
      text-align: left;
      background: #F3F9FC;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }

    .col-9 {
      text-align: left;
      background: #ffffff;
      border: 0.5pt solid #e5eef6;
      padding: 15px 0 15px 20px;
    }
  }

  .quota {
    padding-left: 10px;
    color: #2B79FE;
  }

  .title-min {
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
  }

  .legal {
    width: 50px;
    line-height: revert;
    font-size: 15px;
    color: #333333;
  }

  .el-avatar {
    background: white;
    border: 1px solid #CAD1DA;
    border-radius: 6px;
    height: 50px;
    width: 50px;
    line-height: 48px;
    float: left;
    color: #333333;
  }

  .none-content {
    margin: 10px 30px 20px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid #EEEEEE;
    background: #ffffff;
  }

  .dialog-table {
    display: grid;
    border-spacing: 1px;

    .col-td1 {
      padding: 15px 10px 15px 20px;
      background: #D6E9FF;
      text-align: left;
      color: #333333;
      width: 110px;
      border-spacing: 0px;
    }

    .col-td2 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      width: 35%;
      border-spacing: 0px;
    }

    .col-td3 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      width: auto;
      border-spacing: 0px;
    }
  }

  .el-dialog__wrapper {
    z-index: 9999 !important;
  }
  .table-menu {
    padding: 0px 0px 20px;
  }

  .table-x-table {
    margin: 0px 30px;
    border: 0.5pt solid #e5eef6;
  }
}
</style>